import styled from 'styled-components';

import Button from 'design-system/components/Button';
import Spacer from 'design-system/components/Spacer';
import { Paragraph } from 'design-system/components/Text';
import ChangeEnvs from 'images/dashboard/onboarding/change-envs.gif';

interface RunTestInquiryInProductionStepProps {
  isActivatedOrg: boolean;
  isStepCompleted: boolean;
  isSavingCompletedStep: boolean;
  saveCompletedStep: () => void;
}

const RunTestInquiryInProductionStep = ({
  isActivatedOrg,
  isStepCompleted,
  isSavingCompletedStep,
  saveCompletedStep,
}: RunTestInquiryInProductionStepProps) => {
  return (
    <>
      {isActivatedOrg ? (
        <>
          <Paragraph color='primary'>
            Now that you have Production access, you can switch environments using the toggle on the
            top left corner of your page. In Production, try running another Inquiry and viewing the
            results - this time with <b>live data</b>.
          </Paragraph>
          <Spacer height={2} />
          <ChangeEnvsGif src={ChangeEnvs} />
          <Spacer height={2} />
          {!isStepCompleted && (
            <>
              {isSavingCompletedStep ? (
                <Button disabled width='button'>
                  Saving...
                </Button>
              ) : (
                <Button
                  id='home-sandbox-onboarding-checklist__completed-step-run-test-inquiry-in-production'
                  width='button'
                  onClick={() => {
                    saveCompletedStep();
                  }}
                >
                  Complete step
                </Button>
              )}
            </>
          )}
        </>
      ) : (
        <Paragraph color='primary'>
          Once you have Production access, you’ll be able to run Inquiries with live data.
        </Paragraph>
      )}
    </>
  );
};

const ChangeEnvsGif = styled('img')`
  width: 50%;
`;

export default RunTestInquiryInProductionStep;
